import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface ZigZagHeadingAndAltCtaModel extends BaseModel {
  variables?: { [key: string]: string } | ZigZagHeadingAndAltCtaVariables;
}

export interface ZigZagHeadingAndAltCtaVariables {
  ZigZagHaacHeading: string;
  ZigZagHaacImageHref: string;
  ZigZagHaacImage: string;
  ZigZagHaacImageAlt: string;
  ZigZagHaacText: string;
  ZigZagHaacCtaLink: string;
  ZigZagHaacCtaText: string;
  ZigZagHaacImageHrefSegmentRegex: string;
  ZigZagHaacCtaLinkSegmentRegex: string;
}

export class ZigZagHeadingAndAltCtaInitVariables implements ZigZagHeadingAndAltCtaVariables {
  ZigZagHaacHeading = '';
  ZigZagHaacImage = '';
  ZigZagHaacImageHref = '';
  ZigZagHaacImageAlt = '';
  ZigZagHaacCtaLink = '';
  ZigZagHaacCtaText = '';
  ZigZagHaacText = '';
  ZigZagHaacImageHrefSegmentRegex = '';
  ZigZagHaacCtaLinkSegmentRegex = '';

}

export class ZigZagHeadingAndAltCtaInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ZigZagHeadingAndAltCtaInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
